module.exports = __webpack_public_path__ + "img/icon-no-view.d400a52f.svg";